import { generatePath } from 'react-router';

import { ResourceTypeDto } from '@/api/generated';
import { RouteEnum } from '@/models/route/Route.model.ts';

export const taskContextResourcePath = (
  type: ResourceTypeDto,
  resourceId: string,
): string | undefined => {
  switch (type) {
    case ResourceTypeDto.Car:
      return generatePath(RouteEnum.CARS_DETAILS, { carId: resourceId });
    case ResourceTypeDto.Contact:
      return generatePath(RouteEnum.CONTACTS_DETAILS, { contactId: resourceId });
    case ResourceTypeDto.Customer:
      return generatePath(RouteEnum.CUSTOMERS_DETAILS, { customerId: resourceId });
    case ResourceTypeDto.Process:
      return generatePath(RouteEnum.PROCESSES_DETAILS, { processId: resourceId });
    case ResourceTypeDto.Supplier:
      return generatePath(RouteEnum.SUPPLIERS_DETAILS, { supplierId: resourceId });
    default:
      return undefined;
  }
};
